export enum EventType {
  Event = 'EVENT',
  Course = 'COURSE'
}
